import { PublicClientApplication } from "@azure/msal-browser";
import { config } from "./config";

export const pca = new PublicClientApplication({
  auth: {
    clientId: config.CLIENT_ID,
    authority: `${config.AUTHORITY_URL}/${config.TENANT_ID}`,
    redirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPII) => {
        console.log("System auth error *****", message);
      },
      logLevel: "info",
    },
    tokenRenewalOffsetSeconds: 1800,
  },
});
